module.exports = __webpack_public_path__ + "static/filosofia-461299506cbb6f53892c7303dfb37b3f.webp";